module.exports = __webpack_public_path__ + "img/sort.093e3be5.svg";